import { API } from "../../allApi";
import { haveToApiService } from "../../plugins/axios";
import { ReferralResources, ReferralApiInterface, TopReferralsPayload } from "./types";

const REFERRAL_REWARD_ENDPOINTS: ReferralResources = {
  TRANSFER_REFERRAL_REWARD: {
    URL: API.TRANSFER_REWARDS.URL,
    METHOD: API.TRANSFER_REWARDS.METHOD,
  },
  GET_TOP_REFERRALS: {
    URL: API.TOP_REFERRALS.URL,
    METHOD: API.TOP_REFERRALS.METHOD,
  },
};

const HAVETOApi: ReferralApiInterface = {
  transferRewards: async () => {
    const { response, error } = await haveToApiService({
      resource: REFERRAL_REWARD_ENDPOINTS.TRANSFER_REFERRAL_REWARD,
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    if (error) {
      return { error, referral: null };
    } else {
      return {
        referral: response,
        error: null,
      };
    }
  },
  getTopReferralsDetails: async (payload: TopReferralsPayload) => {
    // Get Weekly Top referrals    
    const { response, error } = await haveToApiService({
      resource: REFERRAL_REWARD_ENDPOINTS.GET_TOP_REFERRALS,
      options: {
        queryParams:

          payload.page && payload.pageSize
            ? {
                page: payload.page ?? null,
                page_size: payload.pageSize ?? null,
                level: payload.level ?? 1,
                start_date: payload.start_date ?? "",
                end_date: payload.end_date ?? "",
                search: payload.search ?? "",
              }
            : null,
      },
    });
    if (error) {
      return { error, topReferrals: null };
    } else {
      return {
        topReferrals: response,
        error: null,
      };
    }
  },
};

export default HAVETOApi;

export { REFERRAL_REWARD_ENDPOINTS };
